import React from 'react'
import { createRoot } from 'react-dom/client'

import './js/airbrake'

import './less/index.less'

import './js/openPlayer.js'
// import './js/player.js'
import './js/lightbox'
import shuffle from './js/shuffle.js'

import Show from './Components/Show.js'
import Shoutout from './Components/Shoutout.js'
import Schedule from './Components/Schedule.js'
import Weather from './Components/Weather'
import News from './Components/News'
import ComingUp from './Components/ComingUp.js'
import CommunityFeed from './Components/CommunityFeed.js'

document.addEventListener('DOMContentLoaded', () => {
  shuffle.init()

  const shows = document.querySelectorAll('show')
  if (shows.length) {
    shows.forEach(show => {
      const root = createRoot(show)
      if (show.getAttribute('next') && show.getAttribute('next') === 'true') return root.render(<Show next={true} />)
      return root.render(<Show />)
    })
  }

  const shoutouts = document.querySelectorAll('shoutout')
  if (shoutouts.length) {
    shoutouts.forEach(shoutout => {
      const root = createRoot(shoutout)
      return root.render(<Shoutout />)
    })
  }

  const schedules = document.querySelectorAll('schedule')
  if (schedules.length) {
    schedules.forEach(schedule => {
      const root = createRoot(schedule)
      return root.render(<Schedule />)
    })
  }

  const weathers = document.querySelectorAll('weather')
  if (weathers.length) {
    weathers.forEach(weather => {
      const root = createRoot(weather)
      return root.render(<Weather />)
    })
  }

  const newss = document.querySelectorAll('news')
  if (newss.length) {
    newss.forEach(news => {
      const root = createRoot(news)
      return root.render(<News />)
    })
  }

  const comingUps = document.querySelectorAll('comingup')
  if (comingUps.length) {
    comingUps.forEach(comingup => {
      const root = createRoot(comingup)
      return root.render(<ComingUp />)
    })
  }

  const communityFeeds = document.querySelectorAll('communityfeed')
  if (communityFeeds.length) {
    communityFeeds.forEach(feed => {
      const root = createRoot(feed)
      return root.render(<CommunityFeed />)
    })
  }
})
